<button mat-icon-button class="close-button" [mat-dialog-close]="false">
    <mat-icon class="close-icon">close</mat-icon>
</button>
<mat-dialog-content>
    <div class="text">
        Inquadra il QR code della porta per aprire la serratura...
    </div>
    <zxing-scanner 
        #scanner
        [formats]="['QR_CODE']"
        class="qrcodeScanner"
        (scanSuccess)="qrcodeReaded($event)"
        (camerasFound)="scannerCamerasFound($event.value)"
    ></zxing-scanner>
    <mat-select
        *ngIf="!isMobile && availableDevices?.length > 1"
        (selectionChange)="onDeviceChange($event.value)"
        placeholder="Scegli la fotocamera"
        class="matSelect">
        <mat-option *ngFor="let device of availableDevices" [value]="device">{{device.label}}</mat-option>
    </mat-select>
</mat-dialog-content>
